export default "__VITE_ASSET__BhoBmLCg__"